export const useDocumentUtils = () => {

  const extractDocuments = (obj, results = []) => {
    if (Array.isArray(obj)) {
      obj.forEach(item => extractDocuments(item, results));
    } else if (obj && typeof obj === "object") {
      if (obj.type === "document" && obj.attributes) {
        const fileInfo = obj.attributes.file || {};
        results.push({
          id: obj.id,
          attributes:{
            categoryName: obj.attributes.categoryName,
            file: {
              name: fileInfo.name,
              url: fileInfo.url
            }
          },
          type: "document"
        });
      }
      Object.values(obj).forEach(value => extractDocuments(value, results));
    }
    return results;
  };

  return {
    extractDocuments
  };
};
